import React from "react";
import 'intl';
import 'intl/locale-data/jsonp/en';
import FederatedResult from '../result';

// Custom class for the result component
class FederatedRecipeResult extends FederatedResult {
  render() {
    const { doc, highlight } = this.props;

    return (
      <li
        className="search-card search-card--recipe tile"
        onClick={() => this.props.onSelect(doc)}
      >
        <a href={this.getCanonicalLink(doc)} >

        <div className="text">

          <h3 className="heading h5" dangerouslySetInnerHTML={{ __html: doc.ss_federated_title }}>
          </h3>

          <p
            className="summary"
            dangerouslySetInnerHTML={{ __html: doc.ss_summary }}
          />

          <div className="meta tags tags--pipe">
            <span className="content-type-tag type">
              {doc.sm_federated_type}
            </span>
          </div>

        </div>
        </a>
      </li>
    );
  }
}

export default FederatedRecipeResult;
